import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../../constants/ActionTypes";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import SubmitOrderMiddlewareProxy from "./SubmitOrderMiddlewareProxy";

export const submitOrderMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  const state = store.getState();

  switch (action.type) {
  case ActionTypes.ORDER.SUBMIT_ACCESSORIES:
    SubmitOrderMiddlewareProxy.orderSubmitAccessory(state, next);
    break;
  case `${MiddlewareEntities.ORDER.ACCESSORIES_ORDER_SUBMIT} ${ActionTypes.API_SUCCESS}` :
    SubmitOrderMiddlewareProxy.orderSubmitAccessoryApiSuccess(next, action.payload);
    break;
  case `${MiddlewareEntities.ORDER.ACCESSORIES_ORDER_SUBMIT} ${ActionTypes.API_ERROR}` :
    SubmitOrderMiddlewareProxy.orderSubmitAccessoryApiError(state, next, action.payload);
    break;
  case ActionTypes.ORDER.SUBMIT:
    SubmitOrderMiddlewareProxy.orderSubmit(state, next);
    break;
  case `${MiddlewareEntities.ORDER.ORDER_SUBMIT} ${ActionTypes.API_SUCCESS}` :
    SubmitOrderMiddlewareProxy.orderSubmitApiSuccess(state, next, action.payload);
    break;
  case `${MiddlewareEntities.ORDER.ORDER_SUBMIT} ${ActionTypes.API_ERROR}` :
    SubmitOrderMiddlewareProxy.orderSubmitApiError(state, next);
    break;
  case ActionTypes.ORDER.CLEAR_BASKET:
    SubmitOrderMiddlewareProxy.orderClearBasket(state, store);
    break;
  }
};

export const orderMiddleware = [submitOrderMiddleware];
